export default __webpack_public_path__ + "static/media/rnr-sports-table-27.bca3dd52.webp";